import { StatusCode } from '../config';
import { APIError } from '../models';

type ValidationProblemBody = { errors?: Record<string, string[]> };

const isValidationProblemBody = (body: unknown): body is ValidationProblemBody =>
    typeof body === 'object' && body !== null && 'errors' in body;

// Reads an ASP.NET ValidationProblemDetails 400 body and returns the first field's messages.
export const getRegistrationValidationMessage = (response: {
    error?: APIError<unknown> | null;
}): string | null => {
    const { error } = response;
    if (error?.response?.status !== StatusCode.BadRequest || !isValidationProblemBody(error.body)) {
        return null;
    }

    const firstField = Object.values(error.body.errors ?? {}).find(
        (messages) => Array.isArray(messages) && messages.length > 0
    );
    return firstField ? firstField.join(' ') : null;
};
